export const JWT_SECRET = process.env.REACT_APP_JWT_SECRET;

export const SERVER_URL = process.env.REACT_APP_API_URL;

export const SMARTLOOK_KEY = process.env.REACT_APP_SMARTLOOK_KEY;
